import React from 'react';

import UserListComponent from '../../components/UserList/user_list_component';
import Sidebar from '../../components/modules/left_sidebar';
import NavBar from '../../components/common/navbar';

const Administration = false;

class UserListPage extends React.Component {
  render() {
    const topBarMenu = this.props.location && this.props.location.state && this.props.location.state.topBarMenu;
    return (
      <div className="dashboard">
        <NavBar
          topBarMenuOption={topBarMenu}
          moduleName="Administration"
        />
        <Sidebar Administration={Administration} />
        <div className="container-fluid">
          <UserListComponent topBarMenuOption={topBarMenu} />
        </div>
      </div>
    );
  }
}

export default UserListPage;
